import React, { useState } from "react";
import { Mail, Phone, MapPin, Send } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import StructuredData from "./StructuredData";

const Contacto = () => {
  const { language, translations } = useLanguage();
  const contacto = translations[language].contacto;
  const [formData, setFormData] = useState({
    nombre: "",
    email: "",
    empresa: "",
    mensaje: "",
  });

  const [loading, setLoading] = useState(false); 

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const REACT_APP_API = process.env.REACT_APP_API_URL || "http://localhost:4000/graphql";
      // Hacemos una petición POST normal y corriente a tu backend
      const respuesta = await fetch(REACT_APP_API, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: `
            mutation EnviarContacto($nombre: String!, $email: String!, $empresa: String, $mensaje: String!) {
              enviarContacto(nombre: $nombre, email: $email, empresa: $empresa, mensaje: $mensaje) {
                exito
                mensaje
              }
            }
          `,
          variables: formData,
        }),
      });

      const resultado = await respuesta.json();

      if (resultado.data.enviarContacto.exito) {
        alert("¡Mensaje enviado con éxito!");
        setFormData({ nombre: "", email: "", empresa: "", mensaje: "" });
      } else {
        alert("Hubo un problema: " + resultado.data.enviarContacto.mensaje);
      }
    } catch (error) {
      console.error("Error al enviar:", error);
      alert("No se pudo conectar con el servidor.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contacto" className="py-20 bg-gray-50 dark:bg-[#4ea7a3]">
      <StructuredData type="contacto" />
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4 text-gray-600 dark:text-white">
            {contacto.titulos.contacto}
          </h2>
          <div className="w-24 h-1 bg-[#12A9B0] mx-auto mb-8"></div>
          <p className="text-xl max-w-3xl mx-auto text-gray-600 dark:text-white">
            {contacto.textos.descripcion}
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          <div className="space-y-8">
            <div>
              <h3 className="text-2xl font-bold mb-4 text-gray-600 dark:text-white">
                {contacto.titulos.hablemosProyecto}
              </h3>
              <p className="text-gray-600 dark:text-white">
                {contacto.textos.introduccion}
              </p>
            </div>

            <div className="space-y-4 text-gray-600 dark:text-white">
              <div className="flex items-center gap-4">
                <Mail size={24} className="text-[#12A9B0] dark:text-white" />
                <div>
                  <div className="font-semibold">
                    {contacto.informacionContacto.email.titulo}
                  </div>
                  <div>{contacto.informacionContacto.email.valor}</div>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <Phone size={24} className="text-[#12A9B0] dark:text-white" />
                <div>
                  <div className="font-semibold">
                    {contacto.informacionContacto.telefono.titulo}
                  </div>
                  <div>{contacto.informacionContacto.telefono.valor}</div>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <MapPin size={24} className="text-[#12A9B0] dark:text-white" />
                <div>
                  <div className="font-semibold">
                    {contacto.informacionContacto.ubicacion.titulo}
                  </div>
                  <div>{contacto.informacionContacto.ubicacion.valor}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-xl">
            <h3 className="text-xl font-bold mb-6 text-[#4b5563]">
              {contacto.titulos.enviaMensaje}
            </h3>

            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                type="text"
                name="nombre"
                required
                value={formData.nombre}
                onChange={handleChange}
                placeholder={contacto.formulario.campos.nombre.placeholder}
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:border-[#12A9B0] text-[#4b5563]"
              />

              <input
                type="email"
                name="email"
                required
                value={formData.email}
                onChange={handleChange}
                placeholder={contacto.formulario.campos.email.placeholder}
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:border-[#12A9B0] text-[#4b5563]"
              />

              <input
                type="text"
                name="empresa"
                value={formData.empresa}
                onChange={handleChange}
                placeholder={contacto.formulario.campos.empresa.placeholder}
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:border-[#12A9B0] text-[#4b5563]"
              />

              <textarea
                name="mensaje"
                required
                value={formData.mensaje}
                onChange={handleChange}
                placeholder={contacto.formulario.campos.mensaje.placeholder}
                className="w-full p-3 border border-gray-300 rounded-lg h-32 resize-none focus:outline-none focus:border-[#12A9B0] text-[#4b5563]"
              />

              <button
                type="submit"
                disabled={loading} // Se desactiva mientras envía
                className={`w-full py-3 text-white rounded-lg font-semibold flex items-center justify-center gap-2 transition-colors 
                  ${loading ? "bg-gray-400 cursor-not-allowed" : "bg-[#12A9B0] hover:bg-[#0e8d92]"}`}
              >
                {loading
                  ? "Enviando..."
                  : contacto.formulario.botones.enviarMensaje}
                <Send size={20} />
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Contacto;
